module.exports = __webpack_public_path__ + "images/star.25ea4220.svg";